import React from "react"

type Props = {
  list: Array<{ cls: string; msg: string }>
}

export const AttentionWord = (props: Props) => {
  return (
    <ul className="attention-message-list">
      {props.list.map((row, i) => (
        <li key={i} className={row.cls}>
          {row.msg}
        </li>
      ))}
    </ul>
  )
}
